// extracted by mini-css-extract-plugin
module.exports = {"timeType":"GameButton_timeType__S95_J","customType":"GameButton_customType__TEKVf"};